import LazyLoad from "vanilla-lazyload";
import Swiper, { Lazy, Navigation, Thumbs } from "swiper";
import StatsChart from "../blocks/stats-chart";
import Gallery from "../blocks/gallery";

const Common = {
  lazyLoadInstance: null,

  init() {
    this.lazyLoadInstance = new LazyLoad();

    StatsChart.init();

    Common.events();
    Common.tabs();
    Common.consultation();
    Common.nextPrev();
    Common.gallerySlider();
    Common.adjustOffsetForAnchortags();
  },

  events() {
    // SEO
    $(".seo-read-more").on("click", function (e) {
      $(this).parent().find(".content-hidden").toggleClass("show");
      $(this).find("span").toggleClass("hidden");
      $(this).find("svg").toggleClass("hidden");
    });

    // Table
    $(".entry-content table").wrap(
      '<div class="scrolltable"><div class="scrolltable__inner"></div></div>'
    );
    $(".scrolltable").scroll(function () {
      $(this).addClass("scrolled");
    });

    // Video.
    $(".js-play-video").on("click", function () {
      $(this).closest(".video").addClass("playing").find("video")[0].play();
    });

    $(".video__overlay").on("click", function () {
      $(this).parent().toggleClass("playing").find("video")[0].pause();
    });

    // Accordion
    $(".accordion").on("click", function () {
      $(this).toggleClass("active").next().slideToggle();
      $(this).parent().toggleClass("active");
    });

    // SEO
    $(".seo__more-btn").on("click", function () {
      let content = document.getElementsByClassName("seo__content-2")[0];
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      let text = $(this).children()[0].innerText;

      if (text == "LASĪT VAIRĀK") {
        $(this).children("span").text("Lasīt mazāk");
      } else {
        $(this).children("span").text("Lasīt vairāk");
      }

      $(this).toggleClass("active");
    });
  },

  /**
   * Tabs
   */
  tabs() {
    // Show first
    $("[data-tabs] [data-container]").not(":first-child").hide();
    $("[data-tabs] [data-target]").first().addClass("active");

    $("[data-target]").on("click", function () {
      const btnEl = $(this);
      const tabEl = btnEl.closest("[data-tabs]");

      const targetTab = btnEl.data("target");

      btnEl.parent().siblings().children().removeClass("active");
      btnEl.addClass("active");

      tabEl.find("[data-container]").hide();
      tabEl.find(`[data-container="${targetTab}"]`).show();
    });

    $('[data-target="1"]').addClass("active");
  },

  nextPrev() {
    $(".nextTab").on("click", function (e) {
      e.preventDefault();
      const activeTab = $(".tabs li.active");
      $(".tabs").find(activeTab).next().click();
      $("html, body").animate(
        { scrollTop: $(".tabs").offset().top - 150 },
        600
      );
    });
    $(".prevTab").on("click", function (e) {
      e.preventDefault();
      const activeTab = $(".tabs li.active");
      $(".tabs").find(activeTab).prev().click();
      $("html, body").animate(
        { scrollTop: $(".tabs").offset().top - 150 },
        600
      );
    });
  },

  /**
   * Consultation Modal
   */
  consultation() {
    const consultationMainDiv = document.querySelector(".consultation");
    if (!consultationMainDiv) {
      return;
    }
    const consultationTrigger = document.querySelector(
      ".consultation__trigger"
    );
    const consultationClose = document.querySelector(".consultation__close");

    consultationTrigger.addEventListener("click", function () {
      consultationTrigger.classList.toggle("active");
      consultationMainDiv.classList.toggle("active");
    });

    consultationClose.addEventListener("click", function () {
      consultationTrigger.classList.remove("active");
      consultationMainDiv.classList.remove("active");
    });
  },

  gallerySlider() {
    new Gallery(".gallery");
  },

  adjustOffsetForAnchortags() {
    // Adjust the offset of linked anchor tags on mobile screens
    const getOffset = () => {
      return $(window).width() < 600 ? 90 : 0; // Adjust the offset values as needed
    };

    $('a[href*="#"]').on('click', (event) => {
      event.preventDefault();

      const href = $(event.currentTarget).attr('href');
      const hashIndex = href.indexOf('#');
      if (hashIndex !== -1) {
        const hash = href.slice(hashIndex);
        const target = $(hash);

        if (target.length) {
          event.preventDefault();
          $('html, body').stop().animate({
            scrollTop: target.offset().top - getOffset()
          }, 1000);
        }
      }
    });
  }
};

export default Common;
